import { blackColors, successColor, warningColor } from 'assets/jss/material-dashboard-pro-react';

const resetPageStyles = {
	rule: {
		fontSize: 14,
		lineHeight: '18px',
		color: blackColors[1],
		letterSpacing: '0.16px !important',
		'& svg': {
			height: 16,
			width: 16,
			marginRight: 8,
			marginBottom: -4,
			color: blackColors[3],
		},
	},
	ruleSuccess: {
		'&, & svg': {
			color: successColor[0],
		},
	},
	ruleError: {
		'&, & svg': {
			color: warningColor[0],
		},
	},
	buttonContainer: {
		textAlign: 'center',
		paddingBottom: 48,
		paddingTop: 47,
	},
	logIn: {
		textAlign: 'center',
		marginBottom: '17px',
		'& a': {
			paddingLeft: '8px',
		},
	},
};

export default resetPageStyles;
